<ra-modal #mainModal [title]="('document.edit.documentConfig.title' | translate)" [size]="'xlarge'" [pushed]="pushed()" (close)="close.emit()">
    <div class="config-body">
        <p class="config-subtitle">{{ 'document.edit.documentConfig.subtitle' | translate }}</p>

        <!-- Seção: Documento -->
        <section class="config-section">
            <h3 class="config-section-title">{{ 'document.edit.documentConfig.sectionDocument' | translate }}</h3>

            <div class="options-card">
                <!-- Mostrar capa -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.showCover' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.showCoverHint' | translate }}</span>
                    </div>
                    <div class="option-row-actions">
                        <button
                            type="button"
                            class="option-edit"
                            (click)="editCover.emit()"
                            [attr.aria-label]="'document.edit.documentConfig.editCover' | translate"
                        >
                            <ra-icon icon="edit-2" varColor="contentSecondary" [size]="18" />
                        </button>
                        <ra-switch [formControl]="form.controls.showCover" />
                    </div>
                </div>

                <!-- Mostrar cabeçalho -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.showHeader' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.showHeaderHint' | translate }}</span>
                    </div>
                    <div class="option-row-actions">
                        <button
                            type="button"
                            class="option-edit"
                            [disabled]="openingEditor() !== null"
                            (click)="editHeader.emit()"
                            [attr.aria-label]="'document.edit.documentConfig.editHeader' | translate"
                        >
                            @if (openingEditor() === 'header') {
                                <ra-loading [size]="'small'" />
                            } @else {
                                <ra-icon icon="edit-2" varColor="contentSecondary" [size]="18" />
                            }
                        </button>
                        <ra-switch [formControl]="form.controls.showHeader" />
                    </div>
                </div>

                <!-- Mostrar rodapé -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.showFooter' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.showFooterHint' | translate }}</span>
                    </div>
                    <div class="option-row-actions">
                        <button
                            type="button"
                            class="option-edit"
                            [disabled]="openingEditor() !== null"
                            (click)="editFooter.emit()"
                            [attr.aria-label]="'document.edit.documentConfig.editFooter' | translate"
                        >
                            @if (openingEditor() === 'footer') {
                                <ra-loading [size]="'small'" />
                            } @else {
                                <ra-icon icon="edit-2" varColor="contentSecondary" [size]="18" />
                            }
                        </button>
                        <ra-switch [formControl]="form.controls.showFooter" />
                    </div>
                </div>

                <!-- Mostrar resumo -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.showSummary' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.showSummaryHint' | translate }}</span>
                    </div>
                    <ra-switch [formControl]="form.controls.showSummary" />
                </div>

                <!-- Cada seção em uma página nova -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.sectionPageBreak' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.sectionPageBreakHint' | translate }}</span>
                    </div>
                    <ra-switch [formControl]="form.controls.sectionPageBreak" />
                </div>

                <!-- Fonte do documento -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.documentFont' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.documentFontHint' | translate }}</span>
                    </div>
                    <div class="option-control">
                        <ra-select [model]="fontSelectModel()" (selectedOption)="onFontSelect($event)" />
                    </div>
                </div>

                <!-- Tamanho do texto -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.textSize' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.textSizeHint' | translate }}</span>
                    </div>
                    <div class="option-control">
                        <ra-select [model]="textSizeSelectModel()" (selectedOption)="onTextSizeSelect($event)" />
                    </div>
                </div>

                <!-- Espaçamento entre linhas -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.lineSpacing' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.lineSpacingHint' | translate }}</span>
                    </div>
                    <div class="option-control">
                        <ra-select [model]="lineSpacingSelectModel()" (selectedOption)="onLineSpacingSelect($event)" />
                    </div>
                </div>

                <!-- Alinhamento do texto -->
                <div class="option-row">
                    <div class="option-text">
                        <span class="option-title">{{ 'document.edit.documentConfig.textAlign' | translate }}</span>
                        <span class="option-description">{{ 'document.edit.documentConfig.textAlignHint' | translate }}</span>
                    </div>
                    <div class="option-control">
                        <ra-select [model]="textAlignSelectModel()" (selectedOption)="onTextAlignSelect($event)" />
                    </div>
                </div>

                <!-- Moeda e layout — só fazem sentido em orçamento (preços e totais). -->
                @if (isQuote()) {
                    <div class="option-row">
                        <div class="option-text">
                            <span class="option-title">{{ 'document.edit.documentConfig.currency' | translate }}</span>
                            <span class="option-description">{{ 'document.edit.documentConfig.currencyHint' | translate }}</span>
                        </div>
                        <div class="option-control">
                            <ra-select [model]="currencySelectModel()" (selectedOption)="onCurrencySelect($event)" />
                        </div>
                    </div>

                    <div class="option-row">
                        <div class="option-text">
                            <span class="option-title">{{ 'document.edit.documentConfig.quoteLayout' | translate }}</span>
                            <span class="option-description">{{ 'document.edit.documentConfig.quoteLayoutHint' | translate }}</span>
                        </div>
                        <div class="option-control">
                            <ra-select [model]="quoteLayoutSelectModel()" (selectedOption)="onQuoteLayoutSelect($event)" />
                        </div>
                    </div>
                }
            </div>
        </section>

        <!--
            Seções de imagens e vídeos com o vocabulário do menu Foto/Grade/Vídeo do rail
            (blocos com desenho, em duas colunas): quem ajusta um card reconhece aqui o padrão
            do documento. O estado vem de `look()`, um signal do formulário.
        -->
        @let state = look();
        <section class="config-section">
            <h3 class="config-section-title">{{ 'document.edit.documentConfig.sectionImages' | translate }}</h3>

            <div class="look-panel">
                <div class="look-columns">
                    <div class="look-col">
                        <!-- Tamanho da imagem única: os prontos acompanham os grupos de 2 e 3 por linha -->
                        <p class="look-title">{{ 'document.edit.documentConfig.singleImageSize' | translate }}</p>
                        <div class="look-grid">
                            @for (grid of sizeOptions; track grid) {
                                <button
                                    type="button"
                                    class="look-option"
                                    [class.current]="state.imageWidth === null && state.singleImageGrid === grid"
                                    (click)="chooseSingleImageSize(grid)">
                                    <look-glyph [name]="sizeGlyph(grid)" />
                                    <span>{{ ('document.edit.documentConfig.singleImageSize' + grid) | translate }}</span>
                                </button>
                            }
                        </div>
                        <p class="look-subtitle">{{ 'document.edit.imageCard.sizeCustom' | translate }}</p>
                        <div class="look-field">
                            <image-width-field
                                [value]="singleImageWidthValue()"
                                [active]="state.imageWidth !== null"
                                (valueChange)="onSingleImageWidth($event)"
                            />
                        </div>

                        <!-- Fotos por linha: o padrão dos grupos novos (os existentes são perguntados) -->
                        <span class="look-divider"></span>
                        <p class="look-title">{{ 'document.edit.railLook.photosPerRow' | translate }}</p>
                        <div class="look-grid">
                            @for (count of sizeOptions; track count) {
                                <button
                                    type="button"
                                    class="look-option"
                                    [class.current]="state.groupImageGrid === count"
                                    (click)="chooseGroupImageGrid(count)">
                                    <look-glyph [name]="colsGlyph(count)" />
                                    <span>{{ count }}</span>
                                </button>
                            }
                        </div>

                        <span class="look-divider"></span>
                        <p class="look-title">{{ 'document.edit.railLook.framing' | translate }}</p>
                        <div class="look-grid" style="--look-cols: 2">
                            <button
                                type="button"
                                class="look-option"
                                [class.current]="!state.fullImage"
                                (click)="setLook('fullImage', false)">
                                <look-glyph name="fit-fill" />
                                <span>{{ 'document.edit.railLook.framingFill' | translate }}</span>
                            </button>
                            <button
                                type="button"
                                class="look-option"
                                [class.current]="state.fullImage"
                                (click)="setLook('fullImage', true)">
                                <look-glyph name="fit-full" />
                                <span>{{ 'document.edit.railLook.framingFull' | translate }}</span>
                            </button>
                        </div>

                        <!-- Cor do fundo: sempre à vista (pedido do usuário). -->
                        <p class="look-subtitle">{{ 'document.edit.mediaFill.title' | translate }}</p>
                        <media-fill-field
                            [value]="state.imageFillColor"
                            (preview)="setFill($event)"
                            (choose)="setFill($event)"
                        />
                        <p class="look-hint">{{ 'document.edit.mediaFill.documentHint' | translate }}</p>
                    </div>

                    <div class="look-col">
                        <!-- Legenda das fotos e dos vídeos: estilo e, na mídia única, a posição -->
                        <p class="look-title">{{ 'document.edit.railLook.caption' | translate }}</p>
                        <div class="look-grid" style="--look-cols: 2">
                            @for (style of captionStyles; track style) {
                                <button
                                    type="button"
                                    class="look-option"
                                    [class.current]="state.captionStyle === style"
                                    (click)="setLook('captionStyle', style)">
                                    <look-glyph [name]="captionGlyph(style)" />
                                    <span>{{ captionStyleLabel(style) | translate }}</span>
                                </button>
                            }
                        </div>
                        <!-- Estilo e posição são ajustes distintos: o subtítulo separa os dois pares. -->
                        <p class="look-subtitle">{{ 'document.edit.railLook.captionPosition' | translate }}</p>
                        <div class="look-grid" style="--look-cols: 2">
                            <button
                                type="button"
                                class="look-option"
                                [class.current]="!state.captionSide"
                                (click)="setLook('captionSide', false)">
                                <look-glyph name="place-below" />
                                <span>{{ 'document.edit.railLook.captionBelow' | translate }}</span>
                            </button>
                            <button
                                type="button"
                                class="look-option"
                                [class.current]="state.captionSide"
                                (click)="setLook('captionSide', true)">
                                <look-glyph name="place-side" />
                                <span>{{ 'document.edit.railLook.captionSide' | translate }}</span>
                            </button>
                        </div>
                        @if (state.captionSide) {
                            <p class="look-hint">{{ 'document.edit.documentConfig.captionSideHint' | translate }}</p>
                        }

                        <span class="look-divider"></span>
                        <p class="look-title">{{ 'document.edit.railLook.showOnPhotos' | translate }}</p>
                        <div class="look-chips">
                            <button
                                type="button"
                                class="look-chip"
                                [class.current]="state.showImageNumber"
                                [attr.aria-pressed]="state.showImageNumber"
                                (click)="setLook('showImageNumber', !state.showImageNumber)">
                                @if (state.showImageNumber) {
                                    <ra-icon icon="check" varColor="currentColor" [size]="12" />
                                }
                                <b aria-hidden="true">#</b>
                                <span>{{ 'document.edit.railLook.showNumber' | translate }}</span>
                            </button>
                            <button
                                type="button"
                                class="look-chip"
                                [class.current]="state.showImageDate"
                                [attr.aria-pressed]="state.showImageDate"
                                (click)="setLook('showImageDate', !state.showImageDate)">
                                @if (state.showImageDate) {
                                    <ra-icon icon="check" varColor="currentColor" [size]="12" />
                                }
                                <ra-icon icon="calendar" varColor="currentColor" [size]="13" />
                                <span>{{ 'document.edit.railLook.showDate' | translate }}</span>
                            </button>
                        </div>

                        <!-- Marca d'água: decisão do documento inteiro, por isso só aqui -->
                        <span class="look-divider"></span>
                        <button
                            type="button"
                            class="look-switch"
                            role="switch"
                            [attr.aria-checked]="state.showImageWatermark"
                            (click)="setLook('showImageWatermark', !state.showImageWatermark)">
                            <span>
                                {{ 'document.edit.documentConfig.showImageWatermark' | translate }}
                                <small>{{ 'document.edit.documentConfig.showImageWatermarkHint' | translate }}</small>
                            </span>
                            <span class="look-toggle" [class.on]="state.showImageWatermark" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="config-section">
            <h3 class="config-section-title">{{ 'document.edit.documentConfig.sectionVideos' | translate }}</h3>

            <div class="look-panel">
                <div class="look-columns">
                    <div class="look-col">
                        <!-- Só a miniatura encolhe: a faixa com o QR code segue na largura toda -->
                        <p class="look-title">{{ 'document.edit.railLook.thumbnailSize' | translate }}</p>
                        <div class="look-grid">
                            @for (grid of sizeOptions; track grid) {
                                <button
                                    type="button"
                                    class="look-option"
                                    [class.current]="state.singleVideoGrid === grid"
                                    (click)="chooseVideoSize(grid)">
                                    <look-glyph [name]="sizeGlyph(grid)" />
                                    <span>{{ ('document.edit.documentConfig.singleImageSize' + grid) | translate }}</span>
                                </button>
                            }
                        </div>
                    </div>

                    <div class="look-col">
                        <!-- Vídeo no PDF: desligado, o vídeo continua no editor e na prévia -->
                        <button
                            type="button"
                            class="look-switch"
                            role="switch"
                            [attr.aria-checked]="state.showVideo"
                            (click)="setLook('showVideo', !state.showVideo)">
                            <span>
                                {{ 'document.edit.railLook.showInPdf' | translate }}
                                <small>{{ 'document.edit.railLook.showInPdfHint' | translate }}</small>
                            </span>
                            <span class="look-toggle" [class.on]="state.showVideo" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <!--
        Footer fixo: status do auto-save + botão Salvar. As alterações já foram gravadas
        neste documento com debounce; o botão só pergunta onde mais elas devem valer.
    -->
    <div class="config-actions">
        @if (loading()) {
            <span class="autosave-status">
                <ra-loading [size]="'small'" />
                {{ 'document.edit.documentConfig.saving' | translate }}
            </span>
        }

        <ra-button
            [label]="'document.edit.documentConfig.applyChanges' | translate"
            [disabled]="!hasChanges()"
            [loading]="savingScope()"
            (click)="saveScope.emit()"
        />
    </div>
</ra-modal>
